module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "other"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-393351ac!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/other.pug
// module id = 806
// module chunks = 1